citySearchService.$inject = ['$http', 'APP_CONFIG'];
function citySearchService($http, APP_CONFIG) {
  return {
    get(params) {
      return $http.get(APP_CONFIG.api.citySearch, { params: params }).then((response) => {
        response.data.forEach(populateViewModelLabels);
        return response.data;
      });
    },
    getByCode(cityCode) {
      return $http.get(`${APP_CONFIG.api.citySearch}/${cityCode}`).then((response) => {
        let city = response.data;
        if (city) {
          populateViewModelLabels(city);
          return city;
        }
        return null;
      });
    },
  };
}

function populateViewModelLabels(city) {
  city.Airports.forEach((airport) => {
    airport.Label = `${airport.Name} (${airport.Value})`;
  });
  city.cityCountry = `${city.City}:${city.Country}`;
  city.label = locationLabel(city);
}

function locationLabel(location) {
  let label = location.City;
  if (location.StateCode) {
    label += `, ${location.StateCode}`;
  }
  label += ` (${location.CountryCode})`;
  return label;
}

export default citySearchService;



// WEBPACK FOOTER //
// ./src/services/citySearchService.js